var Handlebars = require("/Users/mauricengo/styleguide-test/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n<div class=\"notification\">\n  <h3 class=\"notification__head\">Preorder</h3>\n  <p class=\"notification__description\">We'll email you when we have it in stock!</p>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/materials/modules/product-notifications/preorder-email.html
// module id = 165
// module chunks = 0